import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { Stencil } from '../Stencil'; // Todo: Make text and color configurable
// Todo: Use Icon to make icon configurable
// TODO: Consider moving placeholder to it's own component

var Placeholder = function Placeholder(_ref) {
  var width = _ref.width,
      height = _ref.height,
      shimmer = _ref.shimmer,
      text = _ref.text,
      iconWidth = _ref.iconWidth,
      iconHeight = _ref.iconHeight;
  return React.createElement("div", {
    className: "d-inline-block bg-grey-05 t-0 b-0 l-0 r-0 ta-center p-relative",
    style: {
      width: width,
      height: height,
      color: '#C7C7C7',
      zIndex: 2
    }
  }, React.createElement(Stencil, {
    width: width,
    height: height,
    shimmer: shimmer,
    className: "flex flex-center flex-middle"
  }, React.createElement("div", null, React.createElement(Icon, {
    className: "current-fill",
    icon: "picture",
    width: iconWidth,
    height: iconHeight
  }), text && React.createElement("p", {
    className: "fs-body c-inherit"
  }, text))));
};

Placeholder.propTypes = {
  height: PropTypes.string.isRequired,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  text: PropTypes.string,
  width: PropTypes.string.isRequired
};
Placeholder.displayName = 'Placeholder';
export default Placeholder;